import { BasePopup } from "./nineDialog.js";

/**
 *
 */
export class ninePromptPopup extends BasePopup {
	static tagName = 'nine-prompt-popup';

	constructor() {
		super();
	}

	render(message, config) {

		trace.log(this);
		trace.log(this.shadowRoot);

		this.shadowRoot.innerHTML = `
			<style>
				dialog {
					height: 300px !important;
				}
				.msg {
					height: unset !important;
				}
			</style>
			
            <nine-dialog>
                <div class="msg">${message.replace(/\n/g, "<br/>")}</div>
                <div class="input-area">
                    <textarea placeholder="내용을 입력하세요..."></textarea>
                </div>
                <div class="buttons-confirm">
                    <button class="cancel">${config["false-text"]}</button>
                    <button class="ok">${config["true-text"]}</button>
                </div>
            </nine-dialog>`;
	}

	setupEvents(resolve, dialogComp) {
		const textarea = this.shadowRoot.querySelector("textarea");
		const okBtn = this.shadowRoot.querySelector(".ok");

		// 확인 버튼 클릭 시 textarea 값을 가지고 애니메이션 닫기
		okBtn.onclick = () => dialogComp.closeWithAnimation(textarea.value);

		// 렌더링 후 포커스
		requestAnimationFrame(() => textarea.focus());
	}

	static prompt = (m, t, o) => BasePopup.open(ninePromptPopup, m, t, o, (el, msg, conf) => el.render(msg, conf));
}

if (!customElements.get('nine-prompt-popup')) {
	customElements.define('nine-prompt-popup', ninePromptPopup);
}